import EditGMPCourseTaskList from "../../../features/GMPCourseProvider/EditGMPCourseTaskList";

const GmpCourseProviderTaskListApplication = () =>{
    return(<>
    <EditGMPCourseTaskList/>
    </>)
}
export default GmpCourseProviderTaskListApplication;